export default __webpack_public_path__ + "static/media/returns.36c209ac.png";